const initialState = {
    init: {},
    list: [],
    calendars: {default: {}, others: []},
    workingDays: {},
    holidays: [
        {date: null, holiday: null},
        {date: null, holiday: null},
        {date: null, holiday: null}
    ]
}

export default function reducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case "UPDATE_SETTINGS_INIT": 
            return {
                ...state,
                ...action.data,
                init: action.data
            }

        case "UPDATE_SETTINGS_WORKING_DAYS":
            return {
                ...state,
                workingDays: {
                    ...state.workingDays,
                    ...action.day
                }
            }

        case "UPDATE_SETTINGS_ADJUSTED":
            return {
                ...state,
                workingDays: {
                    ...state.workingDays,
                    adjustedSetting: action.value
                }
            }
        
        case "UPDATE_SETTINGS_ADD_HOLIDAYS":
            return {
                ...state,
                holidays: [...state.holidays, action.holiday]
            }

        case "UPDATE_SETTINGS_HOLIDAY":
            return {
                ...state,
                holidays: state.holidays.map((h, i) => {
                    if(i === action.index) {
                        return {
                            ...h,
                            ...action.holiday
                        }
                    }

                    return h;
                })
            }
        
        case "UPDATE_SETTINGS_SUBSCRIPTIONS":
            return {
                ...state,
                calendars: {
                    ...state.calendars,
                    others: action.calendars
                }
            }

        default:
            return state;
    }
}
